import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, ApprovalInboxDialogueHandler } from './types';
import ApprovalInboxDialogueContext from './ApprovalInboxContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type ApprovalInboxDialogueProps = {
  handleDialogue: DialogueHandler<ApprovalInboxDialogueHandler>;
};

type FC = FunctionComponent<ApprovalInboxDialogueProps>;

const ApprovalInboxDialogue: FC = ({ handleDialogue }: ApprovalInboxDialogueProps) => {
  const { approvalInboxError, showApprovalInboxErrorAlert, showUnapprovedTransactions } =
    useContext(ApprovalInboxDialogueContext);
  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.Inbox.Dialogue' });

  return useMemo(
    () => (
      <div>
        {/* Approval Roles Error */}
        <ConfirmationDialogue
          isVisible={showApprovalInboxErrorAlert}
          title={t('ApprovalRolesError.title')}
          status="error"
          subTitle={`${approvalInboxError}`}
          confirm={{
            label: t('ApprovalRolesError.backButton'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
        {/* Unapprove  */}
        <ConfirmationDialogue
          isVisible={showUnapprovedTransactions}
          title={t('UnapproveTransaction.title')}
          status="alert"
          subTitle={t('UnapproveTransaction.subTitle')}
          confirm={{
            label: t('UnapproveTransaction.confirmButton'),
            action: () => handleDialogue({ type: 'unapprove', state: 'confirm' }),
          }}
          close={{
            action: () => handleDialogue({ type: 'unapprove', state: 'cancel' }),
          }}
          buttonWidth="100%"
        />
      </div>
    ),
    [approvalInboxError, showApprovalInboxErrorAlert, showUnapprovedTransactions],
  );
};

export default ApprovalInboxDialogue;
